/**
 * Build a query string for API calls. Tenant `appsCode` is added by {@link @/api/httpClient}
 * from {@link getCurrentUserAppsCode} — never pass it here.
 */
export function requestQuery(
  params?: Record<string, string | number | boolean | undefined | null>,
): string {
  if (!params) {
    return ''
  }
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') {
      continue
    }
    search.set(key, String(value))
  }
  const serialized = search.toString()
  return serialized ? `?${serialized}` : ''
}
